import React from "react";
import { useTranslation } from "react-i18next";

const ClientSearch = ({ onSearch }) => {
  const { t } = useTranslation();

  const handleSearch = (e) => {
    onSearch(e.target.value);
  };

  return (
    <div id="kt_table_1_filter" className="dataTables_filter">
      <label>
        {t("Recherche")}:
        <input
          id="myInput"
          type="text"
          onKeyUp={handleSearch}
          className="form-control form-control-sm"
          placeholder={t("Nom")}
          aria-controls="kt_table_1"
        />
      </label>
    </div>
  );
};

export default ClientSearch;
